import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_flex _gap-2 _mb-5 _pt-4" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_tab = _resolveComponent("base-tab")
  const _component_skeleton_update_feed_card = _resolveComponent("skeleton-update-feed-card")
  const _component_backer_center_update_feed_list = _resolveComponent("backer-center-update-feed-list")
  const _component_load_more_trigger = _resolveComponent("load-more-trigger")
  const _component_backer_center_update_feed_empty_state = _resolveComponent("backer-center-update-feed-empty-state")
  const _component_backer_center_layout = _resolveComponent("backer-center-layout")

  return (_openBlock(), _createBlock(_component_backer_center_layout, {
    title: _ctx.Resources.BackerCenter.SectionUpdatesFeedHeader,
    size: "narrow",
    "current-view": "updates"
  }, {
    default: _withCtx(() => [
      _createElementVNode("nav", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.tabs, (tab) => {
          return (_openBlock(), _createBlock(_component_base_tab, {
            key: tab.key,
            tag: "a",
            href: tab.url,
            title: tab.label,
            variant: "link",
            "is-active": tab.isActive,
            onClick: _withModifiers($event => ($options.onCategoryClick(tab.key)), ["prevent"]),
            "data-qa": `updates-feed:${tab.label}`
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(tab.label), 1 /* TEXT */)
            ]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["href", "title", "is-active", "onClick", "data-qa"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      ($options.isLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(2, (n) => {
            return _createVNode(_component_skeleton_update_feed_card, {
              key: n,
              "data-qa": "updates-feed-skeleton"
            })
          }), 64 /* STABLE_FRAGMENT */))
        : ($options.hasUpdates)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_backer_center_update_feed_list, { updates: $options.mappedPagedItems }, null, 8 /* PROPS */, ["updates"]),
              ($options.isLoadMoreEnabled)
                ? (_openBlock(), _createBlock(_component_load_more_trigger, {
                    key: 0,
                    onLoadMore: $options.loadMoreRows
                  }, null, 8 /* PROPS */, ["onLoadMore"]))
                : _createCommentVNode("v-if", true),
              ($options.isLoadingMore)
                ? (_openBlock(), _createBlock(_component_skeleton_update_feed_card, { key: 1 }))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : ($options.isEmpty)
            ? (_openBlock(), _createBlock(_component_backer_center_update_feed_empty_state, { key: 2 }))
            : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title"]))
}